import { render, staticRenderFns } from "./UserActionButtons.vue?vue&type=template&id=498af7f1&scoped=true"
import script from "./UserActionButtons.vue?vue&type=script&lang=js"
export * from "./UserActionButtons.vue?vue&type=script&lang=js"
import style0 from "./UserActionButtons.vue?vue&type=style&index=0&id=498af7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498af7f1",
  null
  
)

export default component.exports